var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnactiveR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.666 10.4583C17.4993 10 17.3327 9.54167 17.3327 9.08333C17.3327 8.625 17.666 8.16667 18.0827 7.83333C18.791 7.25 19.166 6.375 19.166 5.41667C19.166 3.58333 17.9577 2 15.8327 2C13.8743 2 12.7077 3.33333 12.541 4.95833C12.541 5.125 12.6243 5.25 12.7493 5.33333C14.3327 6.33333 15.291 8.08333 15.291 10.2083C15.291 11.7917 14.666 13.2083 13.541 14.2083C13.4577 14.2917 13.4577 14.4583 13.541 14.5417C13.8327 14.75 14.4993 15.0417 14.916 15.25C15.041 15.2917 15.1243 15.3333 15.2493 15.3333H20.291C21.2493 15.3333 21.9993 14.5417 21.9993 13.6667V13.4167C21.9993 11.9583 20.416 11.1667 18.666 10.4583Z",
    fill: "#8494AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0833 16.2497C11.6667 15.6663 11.4583 15.1663 11.4583 14.6247C11.4583 14.083 11.875 13.5413 12.3333 13.1247C13.1667 12.4163 13.625 11.4163 13.625 10.2497C13.625 8.08301 12.2083 6.20801 9.625 6.20801C7.08333 6.20801 5.625 8.08301 5.625 10.2497C5.625 11.4163 6.08333 12.4163 6.91667 13.1247C7.375 13.5413 7.79167 14.083 7.79167 14.6247C7.79167 15.1663 7.58333 15.708 6.125 16.2497C4.04167 17.083 2 18.0413 2 19.7913V19.9163V20.333C2 21.2497 2.75 21.9997 3.70833 21.9997H15.25C16.2083 21.9997 17 21.2497 17 20.333V19.9163V19.7497C17 18.0413 15.1667 17.083 13.0833 16.2497Z",
    fill: "#8494AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnactiveR);
export default __webpack_public_path__ + "static/media/unactive-r.9cfb0cc5e391317da8bf212f15dd1b3f.svg";
export { ForwardRef as ReactComponent };